import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';

import { useAiIncidents } from '../../entities/ai-incidents';
import { currentEventIdState, currentEventSettings, permissionState } from '../../state/event';
import { AppRoute } from '../../types';
import { CustomTab } from './components/CustomTab';
import { Menu, type MenuProps } from './components/Menu';

type MenuIncidentProps = MenuProps;

export const MenuIncident = (props: MenuIncidentProps) => {
  const { t } = useTranslation();
  const eventId = useRecoilValue(currentEventIdState) ?? 0;
  const settings = useRecoilValueLoadable(currentEventSettings).valueMaybe();
  const { canViewEvent, canViewUsers, canViewMaps, canViewDashboard, canViewAiIncident } =
    useRecoilValue(permissionState);
  const canShowAiIncidents = canViewAiIncident && Boolean(settings?.availableAiIncidentPlan);
  const { data: aiIncidentsData } = useAiIncidents({
    eventId,
    page: 1,
    pageSize: 1,
    enabled: canShowAiIncidents && Boolean(eventId),
  });
  const hasUnreadAiIncidents = aiIncidentsData?.meta.hasUnread ?? false;

  return (
    <Menu {...props}>
      <CustomTab label={t('table')} value={AppRoute.INCIDENTS} />
      {canViewDashboard && <CustomTab label={t('dashboard')} value={AppRoute.DASHBOARD} />}
      {canViewMaps && <CustomTab label={t('map')} value={AppRoute.MAP} />}
      {canViewEvent && <CustomTab label={t('project')} value={AppRoute.EVENTS} />}
      {canViewUsers && <CustomTab label={t('users')} value={AppRoute.USERS} />}
      {canShowAiIncidents && (
        <CustomTab
          label={
            <Box component='span' sx={{ position: 'relative' }}>
              {t('ai-drafts')}
              {hasUnreadAiIncidents && (
                <Box
                  component='span'
                  sx={{
                    width: '6px',
                    height: '6px',
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    transform: 'translateX(12px)',
                    borderRadius: '50%',
                    backgroundColor: '#F2A861',
                  }}
                />
              )}
            </Box>
          }
          value={AppRoute.AI_INCIDENTS}
        />
      )}
    </Menu>
  );
};
